export const stateName = 'fundraiser';